import {ActivityType} from "../../../../typings/activity";
import VideoJS from "../../../../components/VideoJS";
import {VideoJsOptionType} from "../../../../typings/common";
import React, {useEffect, useRef, useState} from "react";

import './video.scss'
import {BEUrl, isYoutubeUrl} from "../../../../utils/common";
import {authenticatedRequestRaw} from "../../../../services/api.service";
import {VIDEO_TYPE_EXTERNAL} from "../../../../constant/activity";
import { Card } from "../../../../components/UI/Card";
interface IVideo {
	activity: ActivityType
}
const Video: React.FC<IVideo> = ({activity}) => {
	const playerRef = useRef(null);
	const [videoJsOptions, setVideoJsOptions] = useState<VideoJsOptionType>({
		autoplay: false,
		controls: true,
		responsive: false,
		fluid: false,
		sources: []
	})
	const [isDone, setIsDone] = useState<boolean>(!!activity?.memberActivities)
	useEffect(() => {
		if(activity){
			let src = `${BEUrl()}static/video/${activity.activity_url}`;
			let type = 'video/mp4';
			if(activity.activity_type === VIDEO_TYPE_EXTERNAL && activity.activity_url){
				src = activity.activity_url
				if(isYoutubeUrl(activity.activity_url)){
					type = 'video/youtube'
				}
			}
			setVideoJsOptions({...videoJsOptions, sources:[
					{ src, type }
				]})
		}
	},[activity])
	const handlePlayerReady = (player: any) => {
		playerRef.current = player;
		player.on('ended', () => {
			saveActivity()
		});
		player.on('dispose', () => {
		});
	};
	const saveActivity = async () => {
		if(!isDone){
			await authenticatedRequestRaw('POST','/course/activity/submit',{
				activity_id: activity?.id,
				course_id: activity?.course_id,
			})
			setIsDone(true);
		}
	}
  return (
    <>
      <div className="flex flex-col w-full">
        <h2 className="font-bold mb-3 text-xl text-center">
          {activity?.title}
        </h2>
        <div
          className="w-full mb-3"
          style={{
            height: "300px",
          }}
        >
          <VideoJS options={videoJsOptions} onReady={handlePlayerReady} />
        </div>
        <Card className="mb-3 p-3">
          <div
            dangerouslySetInnerHTML={{ __html: activity?.description || "" }}
          />
        </Card>
      </div>
    </>
  );
}
export default Video
